import React from 'react';
import { Layout, Button, Typography } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

const { Header } = Layout;

interface BranchNavbarProps {
  onMenuClick: () => void;
  branchName?: string;
}

const BranchNavbar: React.FC<BranchNavbarProps> = ({ onMenuClick, branchName = 'Branch Dashboard' }) => {

  return (
    <Header
      style={{
        position: 'fixed',
        top: 0,
        zIndex: 1000,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        background: '#001529',
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      <Button
        type="text"
        icon={<MenuOutlined />}
        onClick={onMenuClick}
        style={{
          color: 'white',
          fontSize: '16px',
          marginRight: '16px',
        }}
      />
      <Typography.Title
        level={4}
        style={{
          color: 'white',
          margin: 0,
          flex: 1,
        }}
      >
        {branchName} - Medicine CRM
      </Typography.Title>
    </Header>
  );
};

export default BranchNavbar;
